import React from 'react';
import routes from '../../../../../routes/routes';
import MyAccountAuxiliaryNav from './MyAccountAuxiliaryNav';

function MyAccountAuxiliaryNavVM() {
  const helpData = [
    routes.startReturn,
    routes.returnPolicy,
    routes.findStore,
    routes.giftCards,
    routes.contactUs,
  ];

  if (window.FLAGS && window.FLAGS.MentionMe) {
    helpData.splice(0, 0, routes.referAFriend);
  }

  return <MyAccountAuxiliaryNav links={helpData} />;
}

export default MyAccountAuxiliaryNavVM;
